import { gql } from '@apollo/client';

export const GET_PAYMENT_LINK = gql`
  query getPaymentLinkFilteredList($search: PaymentLinkSearchInput, $limit: Int = 1) {
    getPaymentLinkFilteredList(search: $search, limit: $limit) {
      id
      name
      status
      amount
      crossoutPrice
      description
      limit
      expiredAt
      startAt
      notes
      redirectUrl
      createdAt
      link
      type
      reminderWellcomeId
      isDownloadable
      paymentType
      affiliateCommission
      affiliateCommissionType
      content {
        file {
          id
        }
      }
      saasProductInfo {
        activationLimit
        licenseType
        activePeriod
      }
      form {
        fieldObject
        id
        name
      }
      coverImage {
        url
      }
      multipleImage {
        id
        url
        updatedAt
      }
      multipleVideo {
        value
        updatedAt
        id
      }
      checkoutSettings {
        id
        buttonName
        buttonNote
        couponOption
        termOption
        termUrl
        recommendedAmount
        isPopupRecentTransaction
        rateLimit
        qtyLimitPerTransaction
      }
      conversionSettings {
        id
        trackingId
        type
        status
      }
    }
  }
`;
